export class OrganizationSubscriptionModel {
  public subscriptionHashId: string;
  public organizationHashId: string;
  public listOfSubscriptionHashId: string[] = [];
}

export class SubscriptionModel {
  public subscriptionID: number;
  public subscriptionHashId: string;
  public subscriptionName: string;
  public groupName: string;
  public description: string;
  public timeInterval: string = '';
  public amount: number;
  public freeKilometer: string;
  public freeMinute: string;
  public sharedVehicleGroupHashId: string = '';
  public contractTypeGroupList: string[] = [];
  public currencySymbol: string;
  public isChecked: boolean;
  public paymentInterval: string = '';
  public invoiceInterval: string = '';
  public freeKilometerInterval: string = '';
  public freeMinuteInterval: string = '';
  public sharedVehicleSubscriptionHashId:string;
  public subscriptionMapHashId:string;
  public isDeletable:boolean;
}

export class SubscriptionDropDownModel {
  public subscriptionMapHashId: string;
  public name: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/organizationsubscription/models/organization-subscription.model.ts